/**
* DevExpress Analytics (dx-analytics-core-imports.js)
* Version:  20.2.9
* Build date: Aug 16, 2021
* Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./dx-analytics-core-svg-templates");
require("./dx-analytics-core-templates");
require("jquery-ui/ui/widgets/draggable");
require("jquery-ui/ui/widgets/resizable");
require("jquery-ui/ui/widgets/selectable");
require("jquery-ui/ui/widgets/mouse");
require("devextreme/integration/knockout");
require("devextreme/ui/select_box");
require("devextreme/ui/tab_panel");
require("devextreme/ui/color_box");
require("devextreme/ui/date_box");
require("devextreme/ui/tag_box");
require("devextreme/ui/validator");
require("devextreme/ui/validation_group");
require("devextreme/ui/validation_summary");
require("devextreme/ui/accordion");
require("devextreme/ui/check_box");
require("devextreme/ui/radio_group");
require("devextreme/ui/scroll_view");
require("devextreme/ui/themes");
require("devextreme/ui/button");
require("devextreme/ui/text_box");
require("devextreme/ui/popup");
require("devextreme/ui/drop_down_box");
require("devextreme/ui/notify");
require("devextreme/ui/text_area");
require("./core/widgets/bordereditor/_binding");
require("./core/_bindings");
require("./property-grid/widgets/collectioneditor/_bindings");
require("./property-grid/bindings");
require("./widgets/expressioneditor/bindings");
require("./widgets/formatstring/binding");
require("./widgets/treelist/_binding");
require("./widgets/bindings");
